import { Box } from "@mui/material";
import "./styles/animatedTextBorder.css";
import { useThemeContext } from "../../Themes/ThemeContext";


export default function TextBorder({ style = {}, hide = false }) {
    const { theme } = useThemeContext();
    const boxShadow = theme.mode === "dark"?
                    "0px 0px 22px 2px #fff":
                    [
                        "0 0 22px 2px #ec407a",
                        "0 0 23px 2px #ab47bc",
                        "0 0 24px 2px #9c27b0",
                        "0 0 25px 2px #8e24aa",
                    ];
    const color = theme.mode === "dark"? "#fff" : "#000";
    return (
        <Box
            className={"textBorder"} 
            sx={{
                ...style,
                minWidth: "4px",
                height: "41px !important",
                backgroundColor: color,
                color: "#fff",
                borderRadius: "10px",
                marginLeft: "3px",
                boxShadow: boxShadow,
            }}
        >
            
        </Box>
    )
}